import axios from "axios";

const cepService = {
    getAddressFromCEP: (cep) => 
        axios.get('https://viacep.com.br/ws/'+cep+'/json')
};

export default cepService;